//
import { mapActions } from "vuex"

//
import { ModelForm } from "@/components/reusable_components/next"
import Translator from "@/services/translator"
import PosWorkstationUserModel from "@/models/General/GPosWorkstationUser"

//
import fields from "./fields"

//
export default {
    name: "pos-workstation-user-update",
    components: {
        ModelForm,
    },
    computed: {

        /**
         * 
         */
        formProps () {
            return {
                editable: false,
                fields: this.formData.pos_workstation_type_id === 2 ? fields : fields.filter( (e, i) => i !== 5 ),
                switchEdit: true,
            }
        },
    },
    data () {
        return {
            formData: {},
        }
    },
    methods: {

        //
        ...mapActions( "MenuesModule", {
            setTitleTopBar: "setTitleTopBar",
        }),

        /**
         * 
         */
        error ( error ) {
            this.$toast.error( Translator( PosWorkstationUserModel, error.response.data ) )
        },

        /**
         * 
         */
        redirect () {
            this.$router.push({ name: "pos-workstation-user-list" })
        },

        /**
         * 
         */
        reset () {
            PosWorkstationUserModel.modeler().find( this.$route.params.id ).then( this.setFormData )
        },

        /**
         * 
         */
        setFormData ( model ) {
            this.formData = model.reset()
        },

        /**
         * 
         */
        submit () {
            this.$refs.form.setWait( true ).then( this.update )
        },

        /**
         * 
         */
        success () {
            this.$toast.success( "Punto de venta actualizado." )
        },

        /**
         * 
         */
        update ( model ) {
            model
                .request({                            
                    method: "patch",
                    url: [ model.baseURL(), model.resource(), model.g_workstation_user_access_token.id ].join("/"),
                    data: model.toUpdate()
                })
                .then( this.success )
                .then( this.redirect )
                .catch( this.error )
                .then( this.$refs.form.setWait )
        },
    },
    beforeMount () {
        this.setTitleTopBar( "Detalle de punto de venta" )
    },
    mounted () {
        this.reset()
    }
}